<ng-container *ngIf="type === paginationType.OffsetLimit">
  <ngb-pagination [boundaryLinks]="boundaryLinks" [collectionSize]="collectionSize" [maxSize]="maxSize"
    [pageSize]="pageSize" (pageChange)="onPageChange($event)" [page]="page" [rotate]="rotate" [ellipses]="ellipses"
    [disabled]="disabled" aria-label="Default pagination" class="d-flex justify-content-center">
    <ng-template ngbPaginationFirst><i class="fal fa-angle-double-left"></i></ng-template>
    <ng-template ngbPaginationLast><i class="fal fa-angle-double-right"></i></ng-template>
    <ng-template ngbPaginationPrevious><i class="fal fa-angle-left"></i></ng-template>
    <ng-template ngbPaginationNext><i class="fal fa-angle-right"></i></ng-template>
  </ngb-pagination>
</ng-container>


<ng-container *ngIf="type === paginationType.CursorBased">
  <nav aria-label="...">
    <ul class="pagination">
      <li class="page-itemk" [ngClass]="{'disabled': disablePrev}">
        <a class="page-link" (click)="onPrevious()">Previous <<<</a>
      </li>
      <li class="page-itemk disabled">
        <a class="page-linkk">|</a>
      </li>
      <li class="page-itemk" [ngClass]="{'disabled': disableNext}">
        <a class="page-link" (click)="onNext()">Next  >>></a>
      </li>
    </ul>
  </nav>
</ng-container>
